import React from "react";

const NotFound = () => {
  return <div>NotFoundsadd</div>;
};

export default NotFound;
